import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconCloudOff12 from './IconCloudOff12';
import IconCloudOff16 from './IconCloudOff16';
import IconCloudOff20 from './IconCloudOff20';
import IconCloudOff24 from './IconCloudOff24';
import IconCloudOff32 from './IconCloudOff32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconCloudOff = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconCloudOff12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconCloudOff16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconCloudOff20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconCloudOff24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconCloudOff32 {...props} />}
        </span>
    );
};
IconCloudOff.displayName = 'FondueIconCloudOff';

export default memo(IconCloudOff);
